export default __webpack_public_path__ + "static/media/1640.0b12c961.png";